import { anyOwaspToDisplayName } from 'src/app/common/violationRulesUtils';
import { FilterTypesEnum } from '../filters/filterTypes.enum';
import { ISelectOption } from './selectOption.interface';

export const OwaspSelectOptionAll: ISelectOption = {
  id: `${FilterTypesEnum.Owasp.toString()}-all`,
  value: 'all',
  displayName: 'All',
  filterType: FilterTypesEnum.Owasp,
  categoryName: FilterTypesEnum.Owasp.toString(),
};

export const OwaspSelectOptions: ISelectOption[] = Object.keys(anyOwaspToDisplayName).map(
  (attackKey) =>
    ({
      id: `${FilterTypesEnum.Owasp.toString()}-${attackKey}`,
      value: attackKey,
      displayName: anyOwaspToDisplayName[attackKey],
      filterType: FilterTypesEnum.Owasp,
      categoryName: FilterTypesEnum.Owasp.toString(),
    }) as ISelectOption
);

export const OwaspSelectLLMOptions: ISelectOption[] = Object.keys(anyOwaspToDisplayName).map(
  (attackKey) =>
    ({
      id: `${FilterTypesEnum.Owasp.toString()}-${attackKey}`,
      value: attackKey,
      displayName: anyOwaspToDisplayName[attackKey],
      filterType: FilterTypesEnum.Owasp,
      categoryName: FilterTypesEnum.Owasp.toString(),
    }) as ISelectOption
);
